<template>
	<v-chip color="blue lighten-5" text-color="blue lighten-1" class="tracking-number" :class="chipClass" @click="clicked" v-if="trackingNumber">
		<v-avatar :color="color">
			<icon :type="type" :small="true" :white="true"></icon>
		</v-avatar>
		{{trackingNumber}}
	</v-chip>
</template>

<script>
import { requestTypes } from "../enums";
import icon from "./transactions/transaction-type.vue";

export default {
	props: ["type", "trackingNumber", "static"],
	components: {
		icon,
	},
	data() {
		return {};
	},
	computed: {
		color() {
			switch (this.type) {
			case requestTypes.Analysis:
				return "indigo";
			case requestTypes.Report:
				return "purple";
			case requestTypes.Pkg:
				return "pink";
			case requestTypes.Snapshot:
				return "orange";
			default:
				return "";
			}
		},
		chipClass() {
			return this.static ? "static" : "";
		},
	},
	methods: {
		clicked() {
			this.$emit("clicked", this.trackingNumber);
		},
	},
};
</script>
